// Provider-specific identifiers remain internal to the preserved terminal integration.
export function paymentDisplayMessage(value) {
  return String(value || '').replace(/mypos(?:\s+GO\s*2)?/gi, 'terminal de paiement');
}
